import { createNames } from "../../utils";
export const getAceSwiperNames = (id) => {
    return createNames(id, 'ACE-SWIPER', 'CAROUSEL__VIEWPORT', 'CAROUSEL', 'CAROUSEL____FILL', 'CAROUSEL____FILL_1_OF_2', 'CAROUSEL____FILL_1_OF_3', 'CAROUSEL____FILL_1_OF_4', 'CAROUSEL__CONTAINER', 'CAROUSEL__CONTAINER____AUTOPLAY', 'CAROUSEL__LOADER', 'CAROUSEL__LOADER____EMPTY', 'TOP__CONTROLS', 'TOP__ACTIONS', 'TOP', '____HIDDEN');
};
export const aceSwiperSlots = {
    HEADLINE_TAG: 'headline-tag',
    INFO_TAG: 'info-tag',
    LOADER: 'loader'
};
export const aceSwiperCssVariables = {
    GAP__MOBILE: '--ace-swiper-gap--mobile',
    GAP__TABLET: '--ace-swiper-gap--tablet',
    GAP__DESKTOP: '--ace-swiper-gap--desktop',
};
//# sourceMappingURL=ace-swiper.get-names.js.map
